import Vue from 'vue'
import App from './App.vue'
import { store } from '@/store.js'
import Antd from '@/antdvbase.js'
import router from './router.js'
import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false

Vue.use(Antd)

store.dispatch("fetchUserInfo");

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
